import React from 'react'
import { NavLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
const Footer = () =>{
  const { t } = useTranslation();
    const dir = localStorage.getItem('dir');
    return (

      <footer className="footer darkColor" style={{textAlign: window.innerWidth <= 768?'center': '', marginBottom:0}}>
        <ToastContainer position="bottom-right"/>
      <div className="footer-middle" dir={dir} style={window.innerWidth <= 768?{textAlign: 'center'}:{textAlign: dir==='rtl'?'right': 'left'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t('contact_info')}</h4>
                <ul className="contact-info">
                  <li>
                    <span className="contact-info-label">{('Ghayar')}{('E-Commerce')}</span>
                    {/* {('FooterPara1')} */}
                    {t('short_about_us_text')}
                  </li>
                 <div className="row mb-0">
                  <li className="col-md-6">
                      <span className="contact-info-label">{t('phone')}</span>
                      <NavLink to="tel:">
                        {('+971800442522')}
                      </NavLink>
                    </li>
                    <li className="col-md-6">
                      <span className="contact-info-label">{t('email')}</span> 
                      <NavLink to="mailto:contact@ghayar.ae">
                        <span className="__cf_email__">contact@ghayar.ae</span>
                      </NavLink>
                    </li>
                 </div>
                 <div className="row">
                  <li className="col-md-12">
                    <NavLink to={`/Contact`}><span className="contact-info-label">{t('our_location')}</span> </NavLink>
                    <p >
                    {/* {('FooterPara2')} */}
                     {/* {t('address_location')} */}
                    </p>
                  </li>
                  <li className="col-md-6">
                    <span className="contact-info-label">{t('working_hours')}</span> {('8:00AM-7:00 PM')}
                  </li>
                  </div>
                </ul>
                <div className="social-icons" style={window.innerWidth <= 768 ? { display: 'flex', justifyContent: 'center' }: {}}>
                <NavLink to={`https://www.facebook.com/ghayar.ae%20target=`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                  <FacebookIcon />
                </NavLink>
                <NavLink to={`https://www.youtube.com/@ghayarautospareparts8352`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                  <YouTubeIcon />
                </NavLink>
                <NavLink to={`https://www.instagram.com/ghayar.ae`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                  <InstagramIcon />
                </NavLink>
                <NavLink to={`https://bit.ly/2xPA8kY`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                  <XIcon />
                </NavLink>
                  
                </div>
                {/* End .social-icons */}
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t("customer_service")}</h4>
                <ul className="links">
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Faqs`}>{t("help_and_faqs")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Privacy-Policy`}>{t('privacy')}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Delivery`}>{t("delivery_shipment")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Cancelation`}>{t("cancelation_return")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Warranty-Coverage`}>{t("warranty_coverage")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`International-Customers`}>{t("international_customers")}</NavLink></li>
                  {/* <li><NavLink to={`#`}>{t("contact_us")}</NavLink></li> */}
                </ul>
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-2 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t("for_users")}</h4>
                <ul>

                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Signup`}>{t("login")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Signup`}>{t('create_account')}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={localStorage.getItem("customer_id")?`/MyAccount`:`/Signup`}>{t("my_account")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={localStorage.getItem("customer_id")?`/MyAccount/Orders`:`/Signup`}>{t("my_orders")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={localStorage.getItem("customer_id")?`/MyAccount/AccountDetails`:`/Signup`}>{t("profile")}</NavLink></li>
                </ul>
                  
              </div>
              {/* End .widget */}
            </div>
            <div className="col-lg-2 col-sm-6" >
              <div className="widget">
                <h4 className="widget-title">{t("about_us")}</h4>
                <ul>

                <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Aboutus`}>{t("company_info")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Easy-way-to-Shop`}>{t('easy_way_to_shop')}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Safe-Shopping`}>{t("safe_shopping")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Suppliers`}>{t("car_parts_online")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Attractive-Prices`}>{t("attractive_price")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Brands`}>{t("brands")}</NavLink></li>
                  <li><NavLink onClick={() => {window.scrollTo(0, 0);}} to={`/Careers`}>{t("careers")}</NavLink></li>
                </ul>
                  
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-2 col-sm-6">
            <h4 className="widget-title">{t("our_app")}</h4>
              <div className="widget widget-newsletter" style={window.innerWidth <= 768 ? { textAlign: 'center', display: 'flex', justifyContent: 'center' }: {}}>
                
                <ul>
                  <li style={{ paddingBottom : '15px' }}>
                    <img src="assets/images/Files/Our_Apps/apple-store.png" alt={"AppleStore"}  />
                  </li>
                  <li>
                    <img src="assets/images/Files/Our_Apps/google-play.png" alt={"GoogleStore"}  />
                  </li>
                </ul>
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </div>
      {/* End .footer-middle */}
      <div className="container">
        <div className="footer-bottom">
          <div className="container d-sm-flex align-items-center">
            <div className="footer-left">
              <span className="footer-copyright">&copy;Ghayar LLC all rights reserved</span>
            </div>
            <div className="footer-right ml-auto mt-1 mt-sm-0" style={window.innerWidth <= 768 ? { textAlign: 'center', display: 'flex', justifyContent: 'center' }: {}}>
              <div className="payment-icons">
              <table>
                <tbody>
                 
                  <tr>
                    <td>
                      <img style={{height: '30px'}} src="https://ghayar.ae/assets/images/shipping/dhl.jpeg" height="30" alt="DHL" />
                    </td>
                    <td>
                      <img style={{height: '30px'}} src="https://ghayar.ae/assets/images/shipping/smsa.jpeg" height="30" alt="SMSA" />
                    </td>
                    <td>
                      <img style={{height: '30px'}} src="https://ghayar.ae/assets/images/shipping/upslogo.jpg" height="30" alt="UPS" />
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
        {/* End .footer-bottom */}
      </div>
      {/* End .container */}
    </footer>
      );
}

export default Footer;